import React from 'react'
import './TemplatesTable.scss'
import GridItem from 'reactor/components/Grid/GridItem'
import BoxItem from 'reactor/components/Box'

import For from 'reactor/components/For'

import Slider from "react-slick";
import Link from 'reactor/components/Link'

const settings = {
  dots: false,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 3,
  slidesToScroll: 1,
  rtl: true,
  responsive: [
    {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
  ],
};

export default function ServersTable({options, object}) {

    return (
        <BoxItem display="flex" className="templates_table">
            <GridItem xs={6} sm={4} className="templates_table--rightside">
                <div className="templates_table--head">
                    <p>تفاصيل</p>
                    <h3>باقات الخوادم الكاملة</h3>
                </div>
                <For array={options} render={ option => (
                    <div className="templates_table--options">
                        <span>{option}</span>
                    </div>
                )}
                />
            </GridItem>
            <GridItem xs={6} sm={8} >
                <Slider {...settings}>
                    {/* <For array={Templates} render={ item => ( */}
                    { object.map( (item, index)=> (
                        <div key={index} className="templates_table--item">
                            <div className="templates_table--head">
                                <h3>{item.packageName}</h3>
                                <p>خادم كامل</p>
                            </div>
                            <div className="templates_table--options templates_table--options--price">
                                <p>
                                    {item.price}
                                    <span>ريال/سنوي</span>
                                </p>
                            </div>
                            <div className="templates_table--options">
                                <span>{item.processors}</span>
                            </div>
                            <div className="templates_table--options">
                                <span>{item.processorType}</span>
                            </div>
                            <div className="templates_table--options">
                                <span>{item.os}</span>
                            </div>
                            <div className="templates_table--options">
                                <span>{item.space}</span>
                            </div>
                            <div className="templates_table--options">
                                <span>{item.traffic}</span>
                            </div>

                            <div className="templates_table--options">
                                <span>{item.memory}</span>
                            </div>
                            <div className="templates_table--options">
                                <Link to="/contact-us" className={`btn-request dedicatedservers-${item.class}`}>أطلب الآن</Link>
                            </div>

                        </div>
                        ))}
                </Slider>
            </GridItem>
        </BoxItem>
    )
}